var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 113,
    viewBox: "0 0 163 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5307 0.775995V36.296C51.5307 53.464 41.9107 66.636 30.0707 66.636C18.0827 66.636 8.46273 53.464 8.46273 36.296V0.775995H0.618733V36.296C0.618733 57.016 13.9387 74.48 30.0707 74.48C46.2027 74.48 59.3747 57.016 59.3747 36.296V0.775995H51.5307ZM125.445 0.775995C111.977 0.775995 100.137 8.176 96.4372 14.244V0.479999H88.5932V112.368H96.4372V60.716C100.137 66.784 111.977 74.332 125.445 74.332C145.425 74.332 162.149 57.608 162.149 37.48C162.149 17.5 145.425 0.775995 125.445 0.775995ZM125.445 66.34C109.165 66.34 96.4372 53.612 96.4372 37.48C96.4372 21.348 109.165 8.62 125.445 8.62C141.577 8.62 154.305 21.348 154.305 37.48C154.305 53.612 141.577 66.34 125.445 66.34Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/UP.9fd42b9c5a0daefbef7b600feb5fb152.svg";
export { ForwardRef as ReactComponent };